import React, { useRef, useEffect, useState } from 'react';
import { useHttpClient } from '../../hooks/http-hook';
import { Mails, MailX, MailCheck } from 'lucide-react';
import PageHero from '../../components/adminPage/PageHero';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/Card';
import { PulseLoader } from "react-spinners";
const Messages = ({ className }) => {
    const [messages, setMessages] = useState([]);
    const [filteredMessages, setFilteredMessages] = useState([]);
    const [replies, setReplies] = useState({});
    const [filterType, setFilterType] = useState("all");
    const [searchTerm, setSearchTerm] = useState("");
    const { isLoading, sendRequest } = useHttpClient();
    const [selectedMessage, setSelectedMessage] = useState({});

    // Sağ panelin yüksekliğini referansla ölçmek için
    const rightPanelRef = useRef();

    // Bu yükseklik değerini state'te tutacağız
    const [rightPanelHeight, setRightPanelHeight] = useState(0);
    useEffect(() => {
        const fetchMessages = async () => {
            try {
                const responseData = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/form`);
                setMessages(responseData);
                setSelectedMessage(responseData[0])
            } catch (err) { }
        };
        fetchMessages();
    }, [sendRequest]);

    useEffect(() => {
        let filtered = [...messages];

        if (filterType === "replied") {
            filtered = filtered.filter(msg => msg.replies?.length > 0);
        } else if (filterType === "unreplied") {
            filtered = filtered.filter(msg => !msg.replies || msg.replies.length === 0);
        } else {
            filtered = messages
        }

        if (searchTerm.trim()) {
            const term = searchTerm.toLowerCase();
            filtered = filtered.filter(msg =>
                msg.name.toLowerCase().includes(term) ||
                msg.email.toLowerCase().includes(term) ||
                msg.message.toLowerCase().includes(term)
            );
        }

        setFilteredMessages(filtered);

    }, [messages, filterType, searchTerm]);

    const handleReplySubmit = async (messageId) => {
        const replyText = replies[messageId];
        if (!replyText) return;

        try {
            const res = await sendRequest(
                `${process.env.REACT_APP_BACKEND_URL}/admin/${messageId}/reply`,
                "POST",
                JSON.stringify({ text: replyText }),
                { "Content-Type": "application/json" }
            );

            // messages listesini güncelle
            setMessages((prev) =>
                prev.map((msg) => (msg._id === messageId ? res : msg))
            );

            // replies textarea temizle
            setReplies((prev) => ({ ...prev, [messageId]: '' }));

            // eğer şu anda açık olan mesaj buysa onu da güncelle
            if (selectedMessage._id === messageId) {
                setSelectedMessage(res);
            }
        } catch (err) { }
    };

    const handleSelectedMsg = (id) => {
        const result = filteredMessages.filter((item) => item._id === id);
        setSelectedMessage(result[0]);
    }


    const pastelColors = [
        "bg-red-400", "bg-orange-400", "bg-yellow-400", "bg-green-400",
        "bg-teal-400", "bg-blue-400", "bg-indigo-400", "bg-purple-400", "bg-pink-400"
    ];

    // Rengi belirlemek için msg.name'e göre sabit bir index türet
    const getColorClass = (name) => {
        let total = 0;
        for (let i = 0; i < name.length; i++) {
            total += name.charCodeAt(i);
        }
        return pastelColors[total % pastelColors.length];
    };

    useEffect(() => {
        if (rightPanelRef.current) {
            setRightPanelHeight(rightPanelRef.current.offsetHeight);
        }
    }, [selectedMessage, filteredMessages]);
    return (
        <div className={`min-h-screen bg-background pb-20 ${className}`}>
            <PageHero
                pageTitle="Gelen Mesajlar"
                pageSubtitle="Müşterilerden gelen mesajlar ve cevaplarınız"
                children={
                    <>


                        <div className="flex bg-white/10 rounded-lg p-1">
                            {[
                                {
                                    key: "all", label: "Tümü", icon: <Mails size={16} />
                                },
                                {
                                    key: "replied", label: "Cevaplandı", icon: <MailCheck size={16} />
                                },
                                {
                                    key: "unreplied", label: "Cevaplanmadı", icon: <MailX size={16} />
                                }
                            ].map((type) => (
                                <button
                                    key={type.key}
                                    variant={filterType === type.key ? "default" : "ghost"}
                                    size="sm"
                                    onClick={() => {
                                        setFilterType(type.key)
                                    }}
                                    className={`h-auto py-1 flex items-center gap-2 rounded-md px-3 text-primaryForeground ${filterType === type.key ? "bg-white text-primary" : "text-white hover:bg-white/20"} `}
                                >
                                    {type.icon} {type.label}
                                </button>
                            ))}
                        </div>
                        <input
                            type="text"
                            placeholder="Ara: İsim, e-mail, içerik..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="border border-4 border-white/10 bg-white/10 text-white placeholder-white px-4 
                            h-auto py-1 rounded-md shadow-sm text-sm w-full md:w-80 focus:outline-none focus:border-white/30"
                        />
                    </>
                }
            />

            {/* Loading */}
            {/* {isLoading && (
                <div className="flex justify-center items-center py-10 text-blue-600">
                    <Loader2 className="animate-spin mr-2" />
                    Yükleniyor...
                </div>
            )} */}
            <div className='max-w-7xl mx-auto px-6 py-8'>
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-6 items-start'>

                    {/* Mesaj Listesi */}
                    <Card className="shadow-shadowElegant hover:shadow-shadowGlow transition-all duration-300">
                        <CardHeader>
                            <CardTitle className="flex items-center gap-2">
                                <Mails className="h-5 w-5 text-primary" />
                                Mesajlarınız
                            </CardTitle>
                            <CardDescription>Mesaj listeniz...</CardDescription>
                        </CardHeader>

                        <CardContent className="px-6 flex flex-col gap-2 overflow-y-scroll"
                            style={{ maxHeight: rightPanelHeight ? `${rightPanelHeight}px` : 'auto' }}
                        >
                            {
                                filteredMessages.map((msg, index) =>
                                    <div key={msg._id} className='flex items-start gap-3 p-4 cursor-pointer
                                    rounded-lg border border-border hover:bg-muted/50 transition-colors
                                    '
                                        onClick={() => handleSelectedMsg(msg._id)}
                                    >
                                        <div className={`w-8 h-8 uppercase rounded-full flex items-center justify-center text-white text-sm font-semibold ${getColorClass(msg.name)}`}>
                                            {msg.name.slice(0, 1)}
                                        </div>
                                        <div className=''>
                                            <p className="font-semibold text-md text-gray-700">{msg.name}{" - "}<span className="text-sm text-blue-500">{msg.email}</span></p>

                                            <p className="text-xs text-mutedForeground">{new Date(msg.createdAt).toLocaleString()}</p>
                                        </div>
                                    </div>
                                )
                            }



                        </CardContent>
                    </Card>
                    <div className='lg:col-span-2'>
                        {/* Mesajlar */}
                        {selectedMessage && <div ref={rightPanelRef} className="border border-gray-200 rounded-lg shadow-sm bg-white p-6 space-y-4 relative">
                            {/* HEADER */}
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="font-semibold text-md text-gray-700">{selectedMessage.name}{" - "}<span className="text-sm text-blue-500">{selectedMessage.email}</span></p>

                                    <p className="text-xs text-mutedForeground">{new Date(selectedMessage.createdAt).toLocaleString()}</p>
                                </div>
                                <span className={`px-2 py-0.5 text-xs rounded-full ${selectedMessage.replies?.length > 0 ? 'bg-green-100 text-green-700' : 'bg-yellow-100 text-yellow-700'}`}>
                                    {selectedMessage.replies?.length > 0 ? "Cevaplandı" : "Cevap Bekliyor"}
                                </span>
                            </div>
                            <div className='pt-2 border-t mt-4'>
                                <p className="text-mutedForeground text-sm">{selectedMessage.message}</p>
                            </div>
                            {/* REPLIES */}
                            {selectedMessage.replies?.length > 0 && (
                                <div className="space-y-2">
                                    {selectedMessage.replies.map((r, idx) => (
                                        <div key={idx} className="bg-gray-100 px-4 py-2 rounded-md border text-sm">
                                            <p>{r.text}</p>
                                            <p className="text-xs text-gray-500 mt-1">
                                                {r.createdAt ? new Date(r.createdAt).toLocaleString() : 'Tarih bulunamadı'}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* YANITLA */}
                            <div className="pt-2 border-t mt-4">
                                <textarea
                                    rows={2}
                                    value={replies[selectedMessage._id] || ''}
                                    onChange={(e) =>
                                        setReplies((prev) => ({ ...prev, [selectedMessage._id]: e.target.value }))
                                    }
                                    className="w-full min-h-44 border border-gray-300 rounded-md p-2 text-sm focus:outline-none focus:ring focus:border-blue-400"
                                    placeholder="Cevabınızı yazın..."
                                />
                                <div className="flex justify-end mt-2">
                                    <button
                                        onClick={() => handleReplySubmit(selectedMessage._id)}
                                        className="bg-blue-600 hover:bg-blue-700 text-white min-w-44 py-1.5 rounded-md text-sm"
                                    >
                                        {!isLoading ? "Gönder" : <PulseLoader size={6} color={"#fff"} />}
                                    </button>
                                </div>
                            </div>
                        </div>}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Messages;
